import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { injectIntl } from 'react-intl';

const AdminPaymentRefundRow = ({ paymentRefund, intl, deletePaymentRefund }) => {
  function confirmDelete() {
    const confirmMessage = intl.formatMessage({ id: 'payment.refund.view.delete.confirm' });

    if (window.confirm(confirmMessage)) {
      deletePaymentRefund({ paymentRefund });
    }
  }

  return (
    <tr>
      <th scope="row">
        <Link to={`/admin/paymentRefunds/${paymentRefund.id}`} className="link">
          {paymentRefund.id}
        </Link>
      </th>
      <td>{paymentRefund.comment}</td>
      <td>{paymentRefund.amount}€</td>
      <td>
        {paymentRefund.stripeRefundId ? (
          <a target="_blank" href={`https://dashboard.stripe.com/refunds/${paymentRefund.stripeRefundId}`}>
            {paymentRefund.stripeRefundId}
          </a>
        ) : (
          '-'
        )}
      </td>
      <td>
        <button className="btn btn-normal-link" onClick={confirmDelete}>
          Delete
        </button>
        <br />
      </td>
    </tr>
  );
};

AdminPaymentRefundRow.propTypes = {
  paymentRefund: PropTypes.object.isRequired,
};

AdminPaymentRefundRow.defaultProps = {};

export default injectIntl(AdminPaymentRefundRow);
